import { ICarteExplain } from "../../models/component/carteExplain/carteExplain";

const CartesExplain = ({ menu }: ICarteExplain) => {
  return (
    <div className="component-cartes-explain">
      {menu.map((categorie) => (
        <div
          key={`categorie-cartes-${categorie.id}`}
          className="container-categorie-cartes"
        >
          <div className="titleSection">{categorie.name}</div>
          {categorie.content.map((item) => (
            <div
              key={`explain-${item.id}`}
              className="container-details-carte"
            >
              <div className="left-part-details">
                <div className="title-details">{item.name}</div>
                <div className="description-details">{item.description}</div>
              </div>
              <div className="right-part">{item.price} €</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CartesExplain;
